import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  RefundModel,
  RefundMutationDelete,
  RefundMutationInput,
  RefundMutationUpdate,
  RefundMutationUpdateReleasePurchase,
  RefundMutationUpdateReleaseSale,
  ReleasePurchaseModel,
  ReleaseSaleModel,
} from './model';

export function useCreateRefund(
  options?: UseMutationOptions<
    ApiResult<RefundModel>,
    ApiError,
    RefundMutationInput
  >,
): UseMutationResult<ApiResult<RefundModel>, ApiError, RefundMutationInput> {
  return useMutation<ApiResult<RefundModel>, ApiError, RefundMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'refunds',
        method: 'POST',
        body,
      });
    },
    options,
  );
}

export function useUpdateRefund(
  options?: UseMutationOptions<
    ApiResult<RefundModel>,
    ApiError,
    RefundMutationUpdate
  >,
): UseMutationResult<ApiResult<RefundModel>, ApiError, RefundMutationUpdate> {
  return useMutation<ApiResult<RefundModel>, ApiError, RefundMutationUpdate>(
    async function (body) {
      return await MutationFetchFunction({
        url: `refunds/${body.id}`,
        method: 'PUT',
        body: body.body,
        classType: RefundModel,
      });
    },
    options,
  );
}

export function useCancelRefund(
  options?: UseMutationOptions<ApiResult<any>, ApiError, RefundMutationDelete>,
): UseMutationResult<ApiResult<any>, ApiError, RefundMutationDelete> {
  return useMutation<ApiResult<any>, ApiError, RefundMutationDelete>(
    async function (body) {
      return await MutationFetchFunction({
        url: `refunds/${body.id}/cancel`,
        method: 'PATCH',
      });
    },
    options,
  );
}

export function useUpdateRefundReleasePurchase(
  options?: UseMutationOptions<
    ApiResult<any>,
    ApiError,
    RefundMutationUpdateReleasePurchase
  >,
): UseMutationResult<
  ApiResult<ReleasePurchaseModel>,
  ApiError,
  RefundMutationUpdateReleasePurchase
> {
  return useMutation(async function (body) {
    return await MutationFetchFunction({
      url: `refunds/update-release-purchase/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: ReleasePurchaseModel,
    });
  }, options);
}

export function useUpdateRefundReleaseSale(
  options?: UseMutationOptions<
    ApiResult<ReleaseSaleModel>,
    ApiError,
    RefundMutationUpdateReleaseSale
  >,
): UseMutationResult<
  ApiResult<ReleaseSaleModel>,
  ApiError,
  RefundMutationUpdateReleaseSale
> {
  return useMutation(async function (body) {
    return await MutationFetchFunction({
      url: `refunds/update-release-sale/${body.id}`,
      method: 'PUT',
      body: body.body,
      classType: ReleaseSaleModel,
    });
  }, options);
}
